// ** Logo
import { Box, Center } from '@chakra-ui/layout';
import logo from '@src/assets/images/logo/logo.svg';

const SpinnerComponent = () => {
	return (
		<div className="fallback-spinner vh-100">
			<Center height="100%">
				<Box as="img" src={logo} alt="logo" height={100} mb={100} />
				<div className="loading">
					<div className="effect-1 effects"></div>
					<div className="effect-2 effects"></div>
					<div className="effect-3 effects"></div>
				</div>
			</Center>
		</div>
	);
};

export default SpinnerComponent;
